module.exports = __webpack_public_path__ + "static/matching-07f2076bf3c5aa2876a32d8ab6976f93.jpg";